var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRequestedCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 146",
    style: {
      enableBackground: "new 0 0 116 146"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.95,30.29H89c-1.81,0-3.29-1.72-3.29-3.83v-9.86C85.71,9.65,80.31,4,73.67,4H18.9C12.25,4,6.85,9.65,6.85,16.59V131.6 c0,6.95,5.4,12.6,12.05,12.6h81.05c6.65,0,12.05-5.65,12.05-12.6V42.88C112,35.93,106.6,30.29,99.95,30.29z M103.24,131.6 c0,2.11-1.48,3.83-3.29,3.83H18.9c-1.81,0-3.29-1.72-3.29-3.83V16.59c0-2.11,1.48-3.83,3.29-3.83h54.77 c1.81,0,3.28,1.72,3.28,3.83v9.86c0,6.95,5.4,12.59,12.05,12.59h10.95c1.81,0,3.29,1.72,3.29,3.83V131.6z M90.09,91.62H28.76 c-2.42,0-4.38,1.96-4.38,4.38c0,2.42,1.96,4.38,4.38,4.38h61.34c2.42,0,4.38-1.96,4.38-4.38C94.47,93.59,92.52,91.62,90.09,91.62z  M90.09,109.15H28.76c-2.42,0-4.38,1.96-4.38,4.38c0,2.42,1.96,4.38,4.38,4.38h61.34c2.42,0,4.38-1.96,4.38-4.38 C94.47,111.11,92.52,109.15,90.09,109.15z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.19,24.89c-6.51,0-11.81,5.3-11.81,11.81c0,4.44,3,13.65,3.98,16.51c0.38,3.99,3.75,7.11,7.83,7.11 c4.15,0,7.56-3.23,7.85-7.31l3.84-15.35C63.96,37.34,64,37.02,64,36.7C64,30.18,58.7,24.89,52.19,24.89z M52.19,64.25 c-4.34,0-7.87,3.53-7.87,7.87c0,4.34,3.53,7.87,7.87,7.87s7.87-3.53,7.87-7.87C60.06,67.78,56.53,64.25,52.19,64.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequestedCourse);
export default __webpack_public_path__ + "static/media/newRequestedCourse.79f19224e5682aeda1a8cbcdec10543d.svg";
export { ForwardRef as ReactComponent };